import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'ipm-bar',
  templateUrl: './bar.component.html',
  styleUrls: ['./bar.component.scss']
})
export class BarComponent implements OnInit, AfterViewInit {
  @Input() chartId: string = "";
  @Input() chartData: any = "";

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
    }, 1000);
  }

  ngAfterViewInit(): void {
    new Chart(this.chartId,this.makeBarChart());
  }

  makeBarChart () {
    let chartOptions: any = {
      type: 'bar',
      data: {
      datasets: [{
        fill: false,
        backgroundColor: [
          "rgba(185, 152, 255, 1)",
        ],
        borderColor: [
          "rgba(185, 152, 255, 1)",
        ],
        borderWidth: 1
      }]},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            beginAtZero: true,
            // type: 'time',
              grid: {
                display: false,
                tickWidth: 1,
                lineWidth:1,
                zeroLineWidth: 4,
                drawBorder: true,
                zeroLineColor: "#ccc",
                barPercentage: 0.4
              },
              ticks: { 
                color: "rgba(255, 255, 255, 1)",
                fontSize:40
              },
              // time: {
              //   parser: 'MM/DD/YYYY HH:mm',
              //   tooltipFormat: 'll HH:mm',
              //   unit: 'day',
              //   unitStepSize: 1,
              //   displayFormats: {
              //     'day': 'MM/DD/YYYY'
              //   }
              // }
          },
          y: {
            beginAtZero: true,
              grid: {
                display: true,
                tickWidth: 1,
                lineWidth:1,
                drawBorder: true,
                zeroLineWidth: 4,
                zeroLineColor: "#ccc",
              },
              ticks: { 
                color: "rgba(255, 255, 255, 1)",
                font:"20"
              }
          }
        },
        plugins: {
          title: {
            display: false,
            text: 'Custom Chart Title'
        },
        chartAreaBorder: {
          borderColor: 'red',
          borderWidth: 2,
          borderDash: [5, 5],
          borderDashOffset: 2,
        },
          legend: { 
            display: false 
          } 
        }
      }
    };
    if (this.chartData) {
      let labels: Array<any> = [];
      let data: Array<any> = [];
      this.chartData.map((chartOp: any) => {
        labels.push(chartOp.date);
        data.push(chartOp.count)
      });
      chartOptions.data.labels =  labels;
      chartOptions.data.datasets[0].data =  data;
    }
    return chartOptions;
  }

  
}
